<template>
  <div>
    <label :for="name" class="--uppercase">
      <slot></slot>
    </label>
    <select 
        :name="name"
        class="--capitalise"
        v-model="model"
        @change="$event.target.blur()"
        @contextmenu="$event.target.blur()"
    >
      <option
          v-for="instruction in options"
          :key="name + instruction.value"
          :value="instruction.value"
      >
        {{ $t(instruction.label) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    value: Number,
    mutation: String,
    options: Array
  },

  computed: {
    model: {
      get () {
        return this.value;
      },
      set (value) {
        this.$store.commit(this.mutation, value);
      }
    }
  }
}
</script>

<style scoped>

</style>
